// slices/loadingSlice.js
import { createSlice } from "@reduxjs/toolkit";

const initialState = {
  loadingCount: 0,
};

const loadingSlice = createSlice({
  name: "loading",
  initialState,
  reducers: {
    incrementLoading: (state) => {
      state.loadingCount += 1;
    },
    decrementLoading: (state) => {
      state.loadingCount = Math.max(state.loadingCount - 1, 0);
    },
  },
});

export const { incrementLoading, decrementLoading } = loadingSlice.actions;

export default loadingSlice.reducer;
